exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SaveAsSegmentDialog-1dd5e804 .lessMargin-ca98ab07{margin:0 0 20px 0}.SaveAsSegmentDialog-1dd5e804 .successMessage-8bb407ef{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"SaveAsSegmentDialog": "SaveAsSegmentDialog-1dd5e804",
	"lessMargin": "lessMargin-ca98ab07",
	"successMessage": "successMessage-8bb407ef"
};